// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ospteG8uDl8YstIb6sMq{align-items:center;gap:8px;display:flex}.ospteG8uDl8YstIb6sMq .hjLRxXRTgQQnX2gNzUTq{background-color:var(--background-primary-inverted-primary);border-radius:16px;justify-content:center;align-items:center;width:16px;height:16px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appliedFilterButton": `ospteG8uDl8YstIb6sMq`,
	"count": `hjLRxXRTgQQnX2gNzUTq`
};
export default ___CSS_LOADER_EXPORT___;
